module.exports = __webpack_public_path__ + "6025d323acd6d66f74c2beca6bc5247a.png";